import { render, staticRenderFns } from "./UserContactSimpleMenu.vue?vue&type=template&id=4041f0c9&scoped=true&"
import script from "./UserContactSimpleMenu.vue?vue&type=script&lang=js&"
export * from "./UserContactSimpleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041f0c9",
  null
  
)

export default component.exports